(function() {
    angular.module('tmx-app').controller('GuarantorRelationDialogController', ['$mdDialog','$scope','RelationWithInstitutions','tmxUtility','lookupService','showAddButton','TMX_FINANCE_CONSTANTS','guarantorTabEditPrivilege', 'ToastService', 
  
        function GuarantorRelationDialogController($mdDialog,$scope,RelationWithInstitutions,tmxUtility,lookupService,showAddButton,TMX_FINANCE_CONSTANTS,guarantorTabEditPrivilege,ToastService) {
            var exists = tmxUtility.exists;
            $scope.vm = {};
            $scope.vm.RelationWithInstitutionData = RelationWithInstitutions;
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.relationCommitment = false;
            var LkpHiddenValue = TMX_FINANCE_CONSTANTS.LOOKUP_HV;
            
            $scope.vm.lookup = {};
            $scope.vm.lookup.bankRelation = lookupService.getLocalLookupsByType('Relation_with_Bank');  
            $scope.vm.lookup.commitmentType = lookupService.getLocalLookupsByType('Commitment_Type'); 
            $scope.hasCommitment = false;
            //Relationship Change
            $scope.relationChange = function(relationType) {
                if(exists(relationType)) {
                    var HiddenValue = lookupService.getLookupById(relationType).HiddenValue;
                    if(LkpHiddenValue.lebHiddenValue.relationTypeCommitment == HiddenValue) //Religion Other 
                        $scope.relationCommitment = true;
                }
                else {
                    $scope.relationCommitment = false;
                }
            }
            $scope.commitmentChange = function(commitment) {
                if(exists(commitment)) {
                  $scope.hasCommitment = true;
                }
                else {
                    $scope.hasCommitment = false;
                }
            }
  
            $scope.ok = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };
            $scope.add = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide($scope.vm.RelationWithInstitutionData);
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };


            $scope.cancel = function() {
                $mdDialog.hide();
            };
        }]);
})();